import Cache from 'root/cache';
import Backbone from 'backbone';
import Constants from 'root/constants';

export default Backbone.Model.extend({
    defaults: {
        account_id   : 0,
        workspace_id : 0,
        user_id      : 0,
        role         : Constants.ASSIGNEE,
        is_owner     : false,
        is_disabled  : false
    },

    getRoleName: function() {
        switch (this.get('role')) {
            case Constants.ADMIN:
                return 'Admin';
                break;
            case Constants.ASSIGNEE:
                return 'Collaborator';
                break;
            case Constants.CLIENT:
                return 'Guest';
                break;
            default:
                return '';
                break;
        }
    },

    hasAccess: function(access_type, project_id) {
        // 1: check access override
        var access_override = false;
        this.get('access').forEach((access) => {
            if (access.access_type === access_type && access.project_id === project_id) {
                access_override = access;
            }
        });

        if (access_override) {
            return access_override.access_value === 1;
        }

        // 2: fallback to role access
        return Cache.app.checkRoleAccess(access_type, this.get('role'));
    },

    setAccess: function(access_type, access_value, project_id) {
        Cache.app.request({
            action: 'workspace_member/setAccess',
            data: {
                member_id    : this.id,
                access_type  : access_type,
                access_value : access_value,
                project_id   : project_id
            },
            success: (response) => {
                this.set('access', response);
            }
        });
    }
});